// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"82970d4e","211":"e985af40"}[chunkId] + ".chunk.js";
};